import { useQuery } from '@tanstack/react-query'

import { fetchNotificationCount } from '@pepper/utils/src/api/notifications/notifications'

interface Parameter {
  data?: {
    companyId: string
  }
}

const STALE_TIME = 1000 * 60 * 1 // 1 minute

export function useGetNotificationCount({ data }: Parameter) {
  return useQuery({
    queryKey: ['notifications', 'count'],
    queryFn: async () => {
      const result = await fetchNotificationCount(data)
      return result.data
    },
    staleTime: STALE_TIME
  })
}
